export default {
  findServiceslist: { method: "get", url: "services" },
  deleteService: { method: "delete", url: "services/delete{/id}" },
};
